import { useExerciseTaxonomies } from '@entities/exercise'
import { ErrorState, LoadingState } from '@shared/ui/page'
import { ExerciseCatalog } from './catalog'

export const ExercisePage = () => {
	const taxonomies = useExerciseTaxonomies()
	if (taxonomies.isPending) return <LoadingState label='Загрузка справочников упражнений…' />
	if (taxonomies.isError) return <ErrorState error={taxonomies.error} onRetry={() => void taxonomies.refetch()} />
	return <ExerciseCatalog taxonomies={taxonomies.data} />
}
